<template>
    <div>
        <div class="page-breadcrumb">
            <div class="row">
                <div class="col-5 align-self-center">
                    <h4 class="page-title"><i class="fas fa-chart-bar"></i> Reports</h4>
                    <div class="d-flex align-items-center">
                        <nav aria-label="breadcrumb">
                            <ol class="breadcrumb">
                                <li class="breadcrumb-item">
                                    <router-link :to="{name: 'dashboard'}">Home</router-link>
                                </li>
                                <li aria-current="page" class="breadcrumb-item active">
                                    <strong v-if="component === 'purchasesreport'">Purchase Reports</strong>
                                    <strong v-else-if="component === 'salesreport'">Sale Reports</strong>
                                    <strong v-else-if="component === 'invoicesreport'">Invoice Reports</strong>
                                    <strong v-else-if="['quality-report-list', 'view-quality-report'].includes(component)">Quality
                                        Reports</strong>
                                    <strong v-else-if="component === 'view-member-card'">Print</strong>
                                    <strong v-else-if="['purchasesummary', 'salesummary', 'invoicesummary'].includes(component)">Summary
                                        of Reports</strong>
                                    <strong v-else-if="['finance-report-list'].includes(component)">Financial
                                        Reports</strong>
                                    <strong v-else-if="['view-finance-report', 'edit-finance-report', 'new-finance-report'].includes(component)">
                                        <router-link :to="{name: 'finance-report-list'}">Financial Reports</router-link>
                                    </strong>
                                    <strong v-else-if="['my-credentials', 'add-my-credential'].includes(component)">My
                                        Document</strong>
                                </li>
                                <li aria-current="page" class="breadcrumb-item active"
                                    v-if="['view-finance-report', 'edit-finance-report'].includes(component)">
                                    <strong>Financial Report</strong>
                                </li>
                                <li aria-current="page" class="breadcrumb-item active"
                                    v-if="component === 'new-finance-report'">
                                    <strong>New</strong>
                                </li>
                            </ol>
                        </nav>
                    </div>
                </div>
                <div class="col-7 align-self-center">
                    <div class="d-flex no-block justify-content-end align-items-center">
                        <template v-if="show_back_btn.includes(component)">
                            <button @click="$router.go(-1)"
                                    class="btn btn-secondary waves-effect waves-light">
                                <i class="fas fa-arrow-left"></i> Back
                            </button>
                        </template>
                    </div>
                </div>
            </div>
        </div>
        <router-view></router-view>
    </div>
</template>

<script>
    export default {
        name: "GrowersLayout",
        data() {
            return {
                component: null,
                show_back_btn: ['view-quality-report', 'view-finance-report', 'edit-finance-report']
            }
        },
        watch: {
            $route(to, from) {
                this.component = to.name;
            }
        },
        created() {
            this.component = this.$route.name;
        }
    }
</script>

<style scoped>

</style>
